import { FC, useState } from 'react';
import Select from 'react-select';

import { FormFieldProps } from './types';

const FormField: FC<FormFieldProps> = ({
  labelText,
  OptionalText,
  isIcon,
  name,
  type,
  onChange,
  value,
  readonly,
  errors = {},
  touched,
  parentDivClass,
  inputFieldClass,
  placeholder,
  title,
  isSearchable,
  onFocus,
  onBlur,
  maxLength,
  minValue,
  handleLoading = { enable: false, inputValue: '' },
  options,
  className,
  disabled,
  onWheel,
  selectRef,
  customFieldClass,
  showStaricInCaseOfRequired = false,
  showErrorOnChange = false,
  inputDisable = false,
}) => {
  const [isTouched, setIsTouched] = useState<boolean>(false);

  const handleBlur = (e: any) => {
    if (showErrorOnChange) setIsTouched(true); // Mark as touched on blur
    onBlur?.(e); // forward to parent
  };
  const handleChange = (e: any) => {
    if (!isTouched && showErrorOnChange) setIsTouched(true); // Mark as touched on first change
    onChange(e); // forward change
  };

  const showError =
    showErrorOnChange && errors[name] && (touched[name] || isTouched); // ✅ Flexible error visibility

  return (
    <div className={'form-group'}>
      {labelText && !OptionalText ? (
        <label>
          {labelText}
          {showStaricInCaseOfRequired && (
            <span
              className="clr-red-dark"
              style={{ fontFamily: 'sans-serif', paddingLeft: '2px' }}
            >
              *
            </span>
          )}
          <span className="cz-ml-8">{isIcon}</span>
        </label>
      ) : (
        <label className="d-flex justify-content-between">
          {labelText}
          <span className="f-s14 text-transform-none font-rale f-w5 ls-normal">
            {OptionalText}
          </span>
        </label>
      )}
      {type.toLowerCase() === 'select' ||
      type.toLowerCase() === 'multiselect' ? (
        <div className={`form-group ${customFieldClass}`}>
          <Select
            ref={selectRef}
            value={value}
            options={options}
            isDisabled={disabled}
            classNamePrefix="react-select"
            className={`${
              errors[name] && touched[name] ? 'input_error' : ''
            } ${inputFieldClass}`}
            placeholder={placeholder}
            components={{
              IndicatorSeparator: () => null,
            }}
            isSearchable={isSearchable ? true : false}
            onChange={onChange}
            isMulti={type.toLowerCase() === 'multiselect'}
            isClearable={true}
          />
        </div>
      ) : (
        <input
          name={name}
          disabled={disabled}
          type={type}
          className={`form-control ${inputFieldClass ? inputFieldClass : ''} ${
            errors[name] && touched[name] ? 'input_error' : ''
          } ${inputDisable && 'inputDisable'}`}
          onChange={(e) => {
            handleChange(e);
          }}
          value={value}
          placeholder={placeholder}
          readOnly={readonly}
          title={title}
          onBlur={handleBlur}
          onFocus={onFocus}
          maxLength={maxLength}
          min={minValue}
          onWheel={onWheel}
        />
      )}
      {showError && (
        <span className={'clr-dark-red f-s14 font-rale mt-1 d-inline-block'}>
          {errors[name]}
        </span>
      )}
      {!showError && errors && touched && errors[name] && touched[name] && (
        <span className={'clr-dark-red f-s14 font-rale mt-1 d-inline-block'}>
          {errors[name]}
        </span>
      )}
    </div>
  );
};

export default FormField;
